import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { useContext } from 'react';
import { Layout, SimpleHeader, SiteConfigContext } from '@jelly/components';

var Container = _styled("main", {
  target: "ejtz3320",
  label: "Container"
})("line-height:1.5rem;margin:50px auto 100px;padding:0 20px;", function (_ref) {
  var theme = _ref.theme;
  return theme.MQ.M;
}, "{max-width:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.BREAKPOINTS['M'];
}, "px;}strong{", function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.primarySemiBold;
}, "}a{color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.contentLink;
}, ";&:hover{color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.contentLinkHover;
}, ";}}h4{margin-top:2rem;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export var DefaultMarkdown = function DefaultMarkdown(_ref6) {
  var children = _ref6.children,
      frontmatter = _ref6.pageContext.frontmatter;

  var _useContext = useContext(SiteConfigContext),
      _useContext$siteConst = _useContext.siteConstants,
      META_DATA = _useContext$siteConst.META_DATA,
      SITE_HOST = _useContext$siteConst.SITE_HOST;

  return /*#__PURE__*/React.createElement(Layout, {
    inverseLinkColors: true,
    meta: _objectSpread(_objectSpread({}, META_DATA), {}, {
      title: "".concat(frontmatter.title, " - ").concat(META_DATA.applicationName),
      canonical: "".concat(SITE_HOST, "/").concat(frontmatter.breadcrumbs.primary.slug, "/")
    })
  }, /*#__PURE__*/React.createElement(SimpleHeader, {
    breadcrumbs: frontmatter.breadcrumbs,
    canonical: "".concat(SITE_HOST, "/").concat(frontmatter.breadcrumbs.primary.slug, "/"),
    subTitle: frontmatter.subTitle,
    title: frontmatter.title,
    shouldShowLeaderboardAds: false
  }), /*#__PURE__*/React.createElement(Container, null, children));
};